import { Loader2, Truck, Route, CheckCircle2, Bell, ClipboardCheck, Fuel, Receipt, Wrench, CalendarOff } from "lucide-react";
import toast from "react-hot-toast";
import { useDriverDashboard } from "../../hooks/useDriverPortal";
import { useDriverAuth } from "../../context/DriverAuthContext";

function ComingSoon() { toast("This is coming in a future update.", { icon: "🚧" }); }

function QuickAction({ icon: Icon, label, onClick }) {
  return (
    <button onClick={onClick} style={{
      display: "flex", flexDirection: "column", alignItems: "center", gap: 8, padding: "16px 12px",
      background: "#fff", border: "1px solid #E5E7EB", borderRadius: 12, cursor: "pointer", flex: "1 1 100px",
    }}>
      <div style={{ width: 36, height: 36, borderRadius: 10, background: "#EEF2FF", color: "#4F46E5", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Icon size={17} />
      </div>
      <span style={{ fontSize: 12, fontWeight: 600, color: "#374151", textAlign: "center" }}>{label}</span>
    </button>
  );
}

function StatCard({ icon: Icon, label, value, accent }) {
  return (
    <div style={{ flex: "1 1 160px", background: "#fff", border: "1px solid #E5E7EB", borderRadius: 12, padding: "14px 16px", display: "flex", alignItems: "center", gap: 12 }}>
      <div style={{ width: 34, height: 34, borderRadius: 9, background: accent + "17", color: accent, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}><Icon size={16} /></div>
      <div>
        <div style={{ fontSize: 19, fontWeight: 700, color: "#111827" }}>{value}</div>
        <div style={{ fontSize: 11.5, color: "#6B7280" }}>{label}</div>
      </div>
    </div>
  );
}

export default function DriverDashboard({ onNavigate }) {
  const { data, loading } = useDriverDashboard();
  const { driver } = useDriverAuth();

  if (loading || !data) {
    return (
      <main style={{ flex: 1, overflow: "auto", background: "#F9FAFB", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ color: "#9CA3AF", display: "flex", alignItems: "center", gap: 8 }}>
          <Loader2 size={18} style={{ animation: "spin 1s linear infinite" }} /> Loading…
        </div>
      </main>
    );
  }

  return (
    <main style={{ flex: 1, overflow: "auto", background: "#F9FAFB" }}>
      <div style={{ maxWidth: 900, margin: "0 auto", padding: "28px 24px" }}>
        <div style={{ fontSize: 20, fontWeight: 700, color: "#111827", marginBottom: 2 }}>Welcome, {data.name || driver?.name}</div>
        <div style={{ fontSize: 13, color: "#6B7280", marginBottom: 20 }}>Here's what's happening today</div>

        <div style={{ background: "#fff", border: "1px solid #E5E7EB", borderRadius: 12, padding: "16px 18px", marginBottom: 16 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
            <Truck size={15} color="#4F46E5" />
            <div style={{ fontSize: 14, fontWeight: 700, color: "#111827" }}>Assigned Vehicle</div>
          </div>
          {data.assignedVehicle ? (
            <div style={{ fontSize: 15, fontWeight: 700, color: "#111827" }}>{data.assignedVehicle.nickname} — {data.assignedVehicle.plateNumber}</div>
          ) : (
            <div style={{ fontSize: 13, color: "#9CA3AF" }}>No vehicle has been assigned by your fleet owner.</div>
          )}
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: 12, marginBottom: 20 }}>
          <StatCard icon={Route} label="Pending Trips" value={data.pendingTrips} accent="#D97706" />
          <StatCard icon={CheckCircle2} label="Completed Trips" value={data.completedTrips} accent="#16A34A" />
          <StatCard icon={Bell} label="Unread Notifications" value={data.unreadNotifications} accent="#4F46E5" />
        </div>

        <div style={{ fontSize: 13.5, fontWeight: 700, color: "#111827", marginBottom: 10 }}>Quick Actions</div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
          <QuickAction icon={ClipboardCheck} label="Start Inspection" onClick={ComingSoon} />
          <QuickAction icon={Fuel} label="Fuel Entry" onClick={ComingSoon} />
          <QuickAction icon={Receipt} label="Expense Entry" onClick={ComingSoon} />
          <QuickAction icon={Wrench} label="Maintenance Request" onClick={ComingSoon} />
          <QuickAction icon={CalendarOff} label="Leave Request" onClick={ComingSoon} />
          <QuickAction icon={Route} label="My Trips" onClick={() => onNavigate?.("trips")} />
        </div>
      </div>
    </main>
  );
}
